const preloader = document.getElementById("preloader");
const progress = document.getElementById("progressPercent");

if (preloader) {

    let percent = 0;
    let pageLoaded = false;

    window.addEventListener("load", () => {
        pageLoaded = true;
    });

    const interval = setInterval(() => {

        if (pageLoaded) {
            percent += 5;
        } else {
            percent += 1;
        }

        if (percent > 100) {
            percent = 100;
        }

        progress.textContent = percent;

        if (percent === 100) {

            clearInterval(interval);

            preloader.classList.add("hide");

            setTimeout(() => {
                preloader.remove();
            }, 500);

        }

    }, 20);

}



/* ==========================================
   NATIVE VIDEO SYSTEM
========================================== */

const videoPlayers = {};

/* Init */
function initVideos() {
  document.querySelectorAll("video").forEach((video) => {
    videoPlayers[video.id] = video;

    video.muted = true;
    video.playsInline = true;

    // Play/Pause when clicking the video
    video.addEventListener("click", () => {
      togglePlay(video.id);
    });

    const btn = video.parentElement.querySelector(".video-play-btn");
    const posterImg = video.parentElement.querySelector(".video-poster");
    const videoButtonOver = video.parentElement.querySelector(".ffl-video-box-media-btn");

    if (btn) {
      video.addEventListener("play", () => {
        btn.classList.remove("paused");

        if (posterImg) {
          posterImg.classList.add("poster-hidden");
        }
        if(videoButtonOver){
          videoButtonOver.classList.add('hide');
        }
      });

      video.addEventListener("pause", () => {
        btn.classList.add("paused");

        if (posterImg) {
          posterImg.classList.remove("poster-hidden");
        }
        if(videoButtonOver){
          videoButtonOver.classList.remove('hide');
        }
      });

      video.addEventListener("ended", () => {
        btn.classList.add("paused");

        if (posterImg) {
          posterImg.classList.remove("poster-hidden");
        }
        if(videoButtonOver){
          videoButtonOver.classList.remove('hide');
        }

        video.currentTime = 0;
      });
    }

    // Observe all videos
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Autoplay only if the video doesn't have .no-autoplay
            if (!video.classList.contains("no-autoplay")) {
              video.play().catch((err) => {
                console.log("Play blocked:", err);
              });
            }
          } else {
            // Pause every video when it leaves the viewport
            if (!video.paused) {
              video.pause();
            }
          }
        });
      },
      {
        threshold: 0.6,
      },
    );

    observer.observe(video);
  });
}

/* Play / Pause */
function togglePlay(videoId) {
  const video = videoPlayers[videoId];

  if (!video) return;

  if (video.paused) {
    video.play().catch((err) => {
      console.log("Play blocked:", err);
    });
  } else {
    video.pause();
  }
}

/* Mute / Unmute */
function toggleMute(videoId, btn) {
  const video = videoPlayers[videoId];

  if (!video) return;

  if (video.muted) {
    video.muted = false;
    video.volume = 1;

    btn.classList.remove("muted");

    // Mute all other videos
    Object.keys(videoPlayers).forEach((id) => {
      if (id !== videoId) {
        videoPlayers[id].muted = true;

        document
          .querySelectorAll(`button[onclick*="${id}"]`)
          .forEach((button) => {
            button.classList.add("muted");
          });
      }
    });
  } else {
    video.muted = true;
    btn.classList.add("muted");
  }
}

/* Fullscreen */
function toggleFullscreen(videoId) {
    const video = document.getElementById(videoId);

    if (!video) return;

    // Safari iOS / iPadOS
    if (typeof video.webkitEnterFullscreen === 'function') {
        try {
            video.webkitEnterFullscreen();
            return;
        } catch (error) {
            console.warn('Safari fullscreen error:', error);
        }
    }

    // Modern browsers
    if (document.fullscreenElement) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
        return;
    }

    if (video.requestFullscreen) {
        video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
    }
}

/* Start */
document.addEventListener("DOMContentLoaded", () => {
  initVideos();
});

function openFullscreenVideo(videoId) {
    const video = document.getElementById(videoId);

    if (!video) return;

    video.muted = false;
    video.volume = 1;

    const playPromise = video.play();

    if (playPromise !== undefined) {
        playPromise.catch(() => {
            video.muted = true;
            video.play().catch(() => {});
        });
    }

    if (video.requestFullscreen) {
        video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
    } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
    }
}

/* ========================================== */

function createSlotCounter(el) {
  const value = el.dataset.value;
  el.innerHTML = ""; // Reset every time

  [...value].forEach((char, idx) => {
    if (/\d/.test(char)) {
      const reel = document.createElement("div");
      reel.className = "reel";

      const track = document.createElement("div");
      track.className = "reel-track";

      for (let i = 0; i < 50; i++) {
        const span = document.createElement("span");
        span.textContent = i % 10;
        track.appendChild(span);
      }

      reel.appendChild(track);
      el.appendChild(reel);

      const targetDigit = parseInt(char);

      requestAnimationFrame(() => {
        const digitHeight = reel.offsetHeight;
        const stopIndex = 10 + targetDigit;

        track.style.transition = `transform ${2 + idx * 0.15}s cubic-bezier(.17,.84,.44,1)`;
        track.style.transform = `translateY(-${stopIndex * digitHeight}px)`;
      });
    } else {
      const span = document.createElement("span");
      span.className = "static-char";
      span.textContent = char;
      el.appendChild(span);
    }
  });
}

const statsSection = document.querySelector(".about-stats-container");

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        document
          .querySelectorAll(".slot-counter")
          .forEach(createSlotCounter);
      }
    });
  },
  {
    threshold: 0.5,
  }
);

if (statsSection) {
  observer.observe(statsSection);
}


// ----------- HOME SLIDER -----------

const slides = document.querySelectorAll('.vertical-slider2-slides');

function updateScale() {

    slides.forEach((slide, index) => {

        const card = slide.firstElementChild;

        // Last slide always stays at full scale
        if (index === slides.length - 1) {
            card.style.transform = 'scale(1)';
            return;
        }

        const nextSlide = slides[index + 1];
        const nextRect = nextSlide.getBoundingClientRect();

        const start = window.innerHeight;
        const end = 80; // tweak this value

        let progress = (start - nextRect.top) / (start - end);

        progress = Math.max(0, Math.min(1, progress));

        const minScale = 0.90;
        const scale = 1 - (1 - minScale) * progress;

        card.style.transform = `scale(${scale})`;

    });

}

window.addEventListener('scroll', updateScale, { passive: true });
window.addEventListener('load', updateScale);
window.addEventListener('resize', updateScale);